import React from "react";
import PropTypes from "prop-types";
import { Checkbox, Grid, ListItemText, MenuItem, TextField } from "@material-ui/core";

const TODOS = "";

/**
 * Un select de filtro, del ancho de una columna de la fila. `SelectProps`
 * lo vuelve de seleccion multiple (el de estado).
 */
const Selector = ({ etiqueta, valor, onChange, SelectProps, children }) => (
  <Grid item xs={12} sm={6} md={3}>
    <TextField
      select
      fullWidth
      size="small"
      label={etiqueta}
      value={valor}
      onChange={({ target }) => onChange(target.value)}
      SelectProps={SelectProps}
      InputLabelProps={SelectProps ? { shrink: true } : undefined}
    >
      {children}
    </TextField>
  </Grid>
);

Selector.propTypes = {
  etiqueta: PropTypes.string.isRequired,
  valor: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  onChange: PropTypes.func.isRequired,
  SelectProps: PropTypes.object,
  children: PropTypes.node.isRequired,
};

Selector.defaultProps = {
  SelectProps: undefined,
};

/**
 * Los filtros que van encima de la tabla de solicitudes, los mismos en
 * Gestion y en Procesos del solicitante: tipo (opcional), estados con cuantas
 * hay en cada uno, y periodo, con el vigente marcado.
 *
 * En estados se marcan varios; ninguno marcado es "Todos", y elegir "Todos"
 * desmarca los demas.
 *
 * Es controlado: solo pinta y avisa los cambios. Sin `tipos` no se muestra
 * el selector de tipo (en Gestion el tipo se elige antes, en las tarjetas).
 */
const FiltrosSolicitudes = ({
  tipos,
  tipo,
  onTipo,
  estado,
  estados,
  total,
  onEstado,
  periodo,
  periodos,
  vigente,
  onPeriodo,
}) => (
  <Grid container spacing={2} style={{ padding: "8px 16px" }}>
    {tipos && (
      <Selector etiqueta="Tipo" valor={tipo} onChange={onTipo}>
        <MenuItem value={TODOS}>Todos</MenuItem>
        {tipos.map(({ codigo, nombre }) => (
          <MenuItem key={codigo} value={codigo}>
            {nombre}
          </MenuItem>
        ))}
      </Selector>
    )}
    <Selector
      etiqueta="Estado"
      valor={estado}
      onChange={(elegidos) => onEstado(elegidos.includes(TODOS) ? [] : elegidos)}
      SelectProps={{
        multiple: true,
        displayEmpty: true,
        renderValue: (elegidos) =>
          elegidos.length === 0
            ? `Todos${total !== null ? ` (${total})` : ""}`
            : estados
                .filter(({ codigo }) => elegidos.includes(codigo))
                .map(({ nombre }) => nombre)
                .join(", "),
      }}
    >
      <MenuItem value={TODOS}>
        <Checkbox size="small" checked={estado.length === 0} />
        <ListItemText primary={`Todos${total !== null ? ` (${total})` : ""}`} />
      </MenuItem>
      {estados.map(({ codigo, nombre, solicitudes }) => (
        <MenuItem key={codigo} value={codigo}>
          <Checkbox size="small" checked={estado.includes(codigo)} />
          <ListItemText primary={`${nombre} (${solicitudes})`} />
        </MenuItem>
      ))}
    </Selector>
    <Selector etiqueta="Periodo" valor={periodo} onChange={onPeriodo}>
      {periodos.map((nombre) => (
        <MenuItem key={nombre} value={nombre}>
          {nombre}
          {nombre === vigente ? " (vigente)" : ""}
        </MenuItem>
      ))}
    </Selector>
  </Grid>
);

FiltrosSolicitudes.propTypes = {
  /** [{ codigo, nombre }]; sin ella no hay selector de tipo. */
  tipos: PropTypes.array,
  tipo: PropTypes.string,
  onTipo: PropTypes.func,
  /** Codigos marcados; vacio es "Todos". */
  estado: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** [{ codigo, nombre, solicitudes }] */
  estados: PropTypes.array.isRequired,
  /** Total del periodo, para la opcion "Todos"; null si aun no llega. */
  total: PropTypes.number,
  onEstado: PropTypes.func.isRequired,
  periodo: PropTypes.string.isRequired,
  periodos: PropTypes.arrayOf(PropTypes.string).isRequired,
  vigente: PropTypes.string,
  onPeriodo: PropTypes.func.isRequired,
};

FiltrosSolicitudes.defaultProps = {
  tipos: null,
  tipo: TODOS,
  onTipo: () => {},
  total: null,
  vigente: null,
};

export default FiltrosSolicitudes;
